module.exports = __webpack_public_path__ + "img/box-grayed.a129217e.png";